import React from 'react';

import { Redirect, Route, Switch as RouterDomSwitch } from 'react-router-dom';

import {
  LISTING,
  MY_DATA,
  MY_FAVORITES,
  MY_LISTINGS,
  OFFERS,
  TERMS,
  PERFORMANCE,
  PrivateRoute
} from '../../utils/routes';

import { Listing } from '../../rebranding/pages/listing';
import { Ad } from '../../rebranding/pages/ad';
import MyData from '../MyData';
import MyFavorites from '../MyFavorites';
import { GlobalStyles } from '@icarros/ids-react';
import { GlobalStyles as RebrandingProvisoryStyles } from '../../rebranding/styles/globalStyles';
import { ToastContainer } from 'react-toastify';
import { Proposals } from '../../rebranding/pages/proposals';
import { Performance } from '../../rebranding/pages/performance';
import { Terms } from '../Terms';
import { NotFound } from '../NotFound';
import { useWebview } from '../../hooks/useWebview';

export function Switch(): JSX.Element {
  useWebview();

  return (
    <>
      <ToastContainer />
      {process.env.NODE_ENV === 'development' && <GlobalStyles />}
      <RebrandingProvisoryStyles />
      <RouterDomSwitch>
        <Route path={TERMS} exact component={Terms} />

        <PrivateRoute path="/" exact>
          <Redirect to={MY_LISTINGS} />
        </PrivateRoute>
        <PrivateRoute path={MY_DATA}>
          <MyData />
        </PrivateRoute>
        <PrivateRoute path={MY_LISTINGS} component={Listing} />
        <PrivateRoute path={MY_FAVORITES} exact component={MyFavorites} />

        <PrivateRoute path={`${OFFERS}/:id`} component={Proposals} />
        <PrivateRoute path={`${LISTING}/:id${PERFORMANCE}`} exact component={Performance} />
        <PrivateRoute path={`${LISTING}/:id/`} component={Ad} />

        <PrivateRoute path="/404" exact component={NotFound} />
        <Route>
          <Redirect to={'/404'} />
        </Route>
      </RouterDomSwitch>
    </>
  );
}
